import { configureStore } from '@reduxjs/toolkit'

import userReducer from './../../components/UserStore'
import answerStore from 'views/StudentExamTHPT2025/answerStore'

export default configureStore({
  reducer: {
    user: userReducer,
    answer: answerStore
  }
})
